export const useAnalyticsStore = defineWorkspaceConfigStore(
  "dashboards",
  (ctx) => {
    const period = ctx.ref("period");
    const comparison = ctx.ref("comparison", "previous-period");

    return {
      period,
      comparison,
    };
  }
);

export const useHomePageStore = defineWorkspaceConfigStore(
  ["pages", "home"],
  (ctx) => {
    const activeChart = ctx.ref(["today", "chart"], "sales");

    return {
      activeChart,
    };
  }
);
